<script setup lang="ts">
import AuthLayout from "ls/layouts/Auth.vue";
</script>

<template>
  <AuthLayout>
    <template #default>
      <h2 class="text-center font-semibold">
        This page doesn't exist
      </h2>
      <div class="mt-2 text-center text-slate-500">
        Please check the URL
      </div>
    </template>

    <template #secondary>
      <div class="mt-8 text-center text-slate-500">
        If you need some help, email us at <a class="underline" href="mailto:support@axure.com">support@axure.com</a>
      </div>
    </template>
  </AuthLayout>
</template>
